import React from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import NotificationMethodButton from './NotificationMethodButton';
import { FC } from 'react';
interface NotificationMethodSelectorProps {
  hasPhoneContactInfo: boolean;
  hasEmailContactInfo: boolean;
  radio: string;
  onRadioChange: (value: string) => void;
}

const NotificationMethodSelector: FC<NotificationMethodSelectorProps> = ({
  hasPhoneContactInfo,
  hasEmailContactInfo,
  radio,
  onRadioChange
}) => (
  <RadioGroup
    aria-labelledby="share-load-update-methods"
    name="radiogroup-drivers"
    value={radio}
    onChange={(e): void => onRadioChange(e.target.value)}
    sx={{ flexDirection: 'row' }}
  >
    <NotificationMethodButton
      type="phone"
      hasContactInfo={hasPhoneContactInfo}
    />
    <NotificationMethodButton
      type="email"
      hasContactInfo={hasEmailContactInfo}
    />
  </RadioGroup>
);

export default NotificationMethodSelector;
